import type { TweetResponseReferencedTweetTweetEngagementAllOf } from './tweetResponseReferencedTweetTweetEngagementAllOf';
import type { TweetResponseReferencedTweetTweetEngagementAllOfTwo } from './tweetResponseReferencedTweetTweetEngagementAllOfTwo';

export type TweetResponseReferencedTweetTweetEngagement = TweetResponseReferencedTweetTweetEngagementAllOf & TweetResponseReferencedTweetTweetEngagementAllOfTwo;
